<template>
	<article>
		<a @click.prevent="$emit('showModal', data.modal)" href="/" :style="{ backgroundImage: `url(${data.image})` }">
			<span>
				<h3 class="mb-1 font-semibold text-white">{{ data.title }}</h3>
				<p class="mb-1">{{ data.text }}</p>
				<span class="text-primary font-semibold"
					>Show More <svg class="d-none d-lg-block" width="21" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.667 10h11.667m0 0L10.5 4.167M16.334 10 10.5 15.833" stroke="#FA1F63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg
				></span>
			</span>
		</a>
	</article>
</template>

<script>
export default {
	name: "RolesBox",
	props: {
		data: {
			type: Object,
		},
	},
};
</script>

<style lang="scss" scoped>
article {
	border-radius: 1rem;
	overflow: hidden;
	border: 0.3rem solid transparent;
	transition: var(--animation-transition);

	&:hover {
		border-color: var(--global-color-primary);

		span svg {
			left: 90%;
			opacity: 1;
		}

		a:after {
			opacity: 0.6;
		}
	}

	a {
		display: flex;
		height: 23.5rem;
		align-items: end;
		position: relative;

		&:after {
			content: " ";
			position: absolute;
			inset: 0;
			width: 100%;
			height: 100%;
			z-index: 1;
			opacity: 1;
			transition: var(--animation-transition);
			background: linear-gradient(180.03deg, rgba(0, 0, 0, 0) 0.02%, rgba(0, 0, 0, 0.01) 25.22%, rgba(0, 0, 0, 0.75) 49.97%, #000000 99.98%);
		}

		& > span {
			padding: 1.2rem;
			position: relative;
			z-index: 2;
			span {
				display: block;
				position: relative;
				svg {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 40%;
					opacity: 0;
					transition: var(--animation-transition);
				}
			}
		}

		p {
			color: var(--global-color-white);
			font-size: 0.9rem;
		}

		h3 {
			font-size: 1.1rem;
		}
	}
}
</style>
